module.exports = __webpack_public_path__ + "img/u69.bd73643d.png";